import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../_services/seo/seo.service';
import { EvenementService } from '../../_services/evenement/evenement.service';
import { Evenement } from '../../_interfaces/evenement';

import { RouterModule } from '@angular/router';
import { EvenementCardComponent } from '../../_components/evenement-card/evenement-card.component';

@Component({
    selector: 'app-evenements',
    imports: [RouterModule, EvenementCardComponent],
    templateUrl: './evenements.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./evenements.component.scss']
})
export class EvenementsComponent {
  evenementService = inject(EvenementService);
  evenements: Evenement[] = [];

  private seo = inject(SeoService);

  constructor() {
    this.seo.set({
      title: 'Événements',
      description: 'Les prochains spectacles, festivals et animations de La Bourrée de Paris, groupe folklorique auvergnat de Paris.',
      path: '/evenements',
    });
    this.readEvenements();
  }

  readEvenements(){
    this.evenementService.readAllFuturePublicEvenements().subscribe(
      evenements => {
        this.evenements = evenements
      },
      error => {
        console.error('Une erreur est survenue :', error);
      }
    );
  }
} 